import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { SwUpdateService } from '../../services/sw-update.service';

/**
 * Release notes for the current version. Empty until there are any; the
 * "updated" bar then leaves the link out.
 */
export const RELEASE_NOTES_URL = '';

/**
 * The bar across the top of the page: a new version is ready, the running one
 * cannot keep working, or (after "Update now") the update was applied. None
 * takes keyboard focus, so a keystroke meant for a form can never press one of
 * their buttons.
 */
@Component({
  selector: 'app-update-prompt',
  templateUrl: './app-update-prompt.component.html',
  imports: [MatButtonModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppUpdatePromptComponent {
  // The bar's background colours (tailwind `primary`, as on the sidebar and the
  // primary buttons, and `red`), reused for the label of its white button.
  readonly barColors = { update: '#3B8E74', reload: '#E34234' };
  readonly releaseNotesUrl = RELEASE_NOTES_URL;

  constructor(public update: SwUpdateService) {}
}
